<template>
  <d2-container>
    <h2>签章申请列表</h2>
    <!--筛选条件区域-->
    <el-form ref="elForm" :model="listQuery" size="medium" label-width="110px">
      <el-row type="flex" justify="start" align="top">
        <el-form-item label="注册区县">
          <town-com v-on:on-selectLast="(e)=>listQuery.addressStreetId=e"></town-com>
        </el-form-item>
        <el-form-item label="企业类型">
          <el-select v-model="listQuery.entType" placeholder="请选择企业类型" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in entTypeOptions" :key="index" :label="item.label" :value="item.value"
                       :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="start" align="top">
        <el-form-item  label="企业名称">
          <el-input v-model="listQuery.entName" placeholder="请输入企业名称"
                    clearable :style="{width: '545px'}"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
          <el-button size="small" @click="resetForm">重置{{tabName}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <!--添加区域-->
    <!--表格分页列表-->
    <el-tabs v-model="tabName" @tab-click="handleFilter">
      <el-tab-pane label="使用中" :name="0"></el-tab-pane>
      <el-tab-pane label="签章列表" :name="1"></el-tab-pane>
    </el-tabs>
    <div  v-if="tabName==0">
        <el-table :data="list" v-loading.body="listLoading" size="small" stripe
              highlight-current-row
              style="width: 100%" >
      <el-table-column
              type="selection"
              width="55" label="序号">
      </el-table-column>
      <el-table-column
              fixed
              prop="date"
              label="企业名称"
              width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.entName }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="province"
              label="所属街镇"
              width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.addressStreetName }}/{{ scope.row.addressStreetDetail }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="city"
              label="法人代表"
              width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.legalName }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="address"
              label="联系人">
        <template slot-scope="scope">
          <span>{{ scope.row.contactName }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="address"
              label="车辆">
        <template slot-scope="scope">
          <span>0</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="userTotal"
              label="人员">
      </el-table-column>
      <el-table-column
              prop="signatureCount"
              label="可用签章数" >
      </el-table-column>
      <el-table-column
              fixed="right"
              align="center"
              width="300"
              label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="handleCreate(scope.row)">签章申请</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div v-else :key="tabName">
        <el-table :data="list" v-loading.body="listLoading" size="small" stripe
                highlight-current-row
                style="width: 100%" >
        <el-table-column
            type="selection"
            width="55" label="序号">
        </el-table-column>
        <el-table-column
            fixed
            prop="date"
            label="企业名称"
            width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.enterprise.entName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="province"
            label="所属街镇"
            width="240">
          <template slot-scope="scope">
            <span>{{ scope.row.enterprise.addressStreetName }}/{{ scope.row.enterprise.addressStreetDetail }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="city"
            label="法人代表"
            width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.enterprise.legalName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="address"
            label="联系人">
          <template slot-scope="scope">
            <span>{{ scope.row.enterprise.contactName }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="signatureCount"
            label="可用签章数" >
        </el-table-column>
        <el-table-column
            prop="signatureNum"
            label="申请签章数">
        </el-table-column>
          <el-table-column
                  prop="status"
                  label="状态">
            <template slot-scope="scope">{{statusFun(scope.row.status)}}</template>
          </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </template>

    <!--表单添加更新区域-->
    <el-dialog :fullscreen="false" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form" label-width="150px">
        <el-form-item label="企业名称" >
          {{ form.entName }}
        </el-form-item>
        <el-form-item label="可用签章数" >
          {{form.signatureCount}}
        </el-form-item>
        <el-form-item label="申请签章数" >
          <el-input v-model="form.signatureNum" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="依据条件" >
          <el-radio-group v-model="form.type">
            <el-radio label="0">免费赠送</el-radio>
            <el-radio label="1">企业充值购买</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="凭证上传"  v-if="form.type==1">
          <upload-component v-on:on-upload="e=>form.filePath=e.fileSerial" :show="true"></upload-component>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button v-if="dialogStatus=='create'" size="small" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>

  </d2-container>
</template>


<script>
    import uploadComponent from '../common/upload-com.vue'
    import TownCom from "../common/town-com.vue";
    import {
        pageList,
        addObj,
        delObj,
        getObj,
        putObj,
    } from '@/api/admin/sysEnterpriseSignature/index';
    import {
      signList
    } from '@/api/admin/sysEnterprise/index';

    import {mapGetters} from 'vuex';
    export default {
        name: 'sysEnterpriseSignature',
        components: {
          TownCom, uploadComponent
        },
        data() {
            return {
                tabName: 0,
                listQuery: {
                    page: 1,
                    limit: 20,
                    status: "3",
                    entName: null,
                    entType: null,
                    addressStreetId: null,
                },
                entTypeOptions: [{
                    "label": "加油",
                    "value": 0
                }, {
                    "label": "供油",
                    "value": 1
                }],

                list: null,
                total: null,
                listLoading: true,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '签章申请'
                },
                form:{
                    entId: null,
                    entName:null,
                    signatureCount:null,
                    signatureNum:null,
                    type: null,
                    filePath:null,
                }
            }
        },
        /**
         * 创建实例执行
         */
        created() {
        },
        mounted() {
            this.getPageList();
        },
        watch:{
        },
        computed: {
            ...mapGetters([
                'elements'
            ]),
        },
        methods: {
            statusFun(status){
              if(status==0){
                return "待提交";
              }else if(status==1){
                return "等待审核";
              }else if(status==2){
                return "被驳回";
              }else if(status==3){
                return "已通过";
              }else if(status==-1){
                return "不通过";
              }
              return "";
            },
            getPageList() {
                this.listLoading = true;
                if(this.tabName=='0'){
                  signList(this.listQuery).then(response => {
                      this.list = response.rows;
                      this.total = response.total;
                      this.listLoading = false;
                  })
                }else if(this.tabName=='1'){
                  pageList({...this.listQuery, statusList: []}).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                  })
                }
                this.listLoading = false;
            },
            handleFilter(tab) {
              this.getPageList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getPageList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getPageList();
            },
            handleCreate(data) {
                this.resetTemp();
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
                let formData = Object.assign(data, data.enterprise);
                this.form.entId = formData.entId;
                this.form.entName = formData.entName;
                this.form.signatureCount = formData.signatureCount;
            },
            handleUpdate(row) {
                getObj(row.qzId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'update';
                    });
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.qzId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },

            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        console.log(this.form);
                        this.form.status=1;
                        addObj(this.form)
                            .then(() => {
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.form.password = undefined;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleOpen(row) {
                this.enterpriseId = row.qzId;
                if(row.status==0){
                    this.$nextTick(()=>{
                        const entOpen = this.$refs.entOpen;
                        entOpen.restTemp();
                        entOpen.initOpen();
                    })
                }else if(row.status==4){//查询开通记录信息
                    let param = {};
                    param.qzId = this.enterpriseId;
                    rejectOpenDetail(param).then(result => {
                        this.initRejectOpenDetailObj = result;
                        console.log(this.initRejectOpenDetailObj);
                        this.$nextTick(()=>{
                            const entOpen = this.$refs.entOpen;
                            entOpen.restTemp();
                            entOpen.initRejectOpenDetail();
                        })
                    })
                }

                this.dialogOpenFormVisible = true;
            },
            handleClick(row) {
                let param = {};
                param.qzId = row.qzId;
                enterpriseDetail(param).then(result => {
                    if (result.statusCode == 200) {
                        this.enterpriseDetailObj = result.data;
                        this.enterpriseDetailObj.status = row.status;
                        this.$nextTick(()=>{
                            const detail = this.$refs.entDetail;
                            detail.initDetail();
                        })
                        this.toExamineVisible = true
                        ;
                    } else {
                        this.$notify({
                            title: '查询详情失败',
                            message: '查看详情失败',
                            type: 'error',
                            duration: 2000
                        });
                    }
                })
            },
            resetTemp() {
                // this.contractFile = undefined,
                this.form = {

                };
            },
            resetForm() {
                this.listQuery = {
                  page: 1,
                  limit: 20,
                  status: "1",
                  entName: null,
                  entType: null,
                  addressStreetId: null,
                };
                this.areaOptions = [];
            },
        }
    }
</script>

